export const DEFAULT_ATTRIBUTES = {
  BATTERY: 'battery',
  LINK_QUALITY: 'linkquality',
};
